import { Link } from 'react-router-dom';

const featureCards = [
  {
    name: 'Pants/Shorts',
    desc: 'Calças e shorts tendência',
    price: 'Desde $18',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Denim%20jeans%20and%20chino%20shorts%20hanging%20on%20clothing%20rack%20in%20boutique%20store%2C%20natural%20shop%20lighting%20from%20above%2C%20fashion%20retail%20photography%2C%20warm%20commercial%20interior%2C%20casual%20shopping%20vibe&width=500&height=500&seq=feat-v2-pants&orientation=squarish',
  },
  {
    name: 'Headwear',
    desc: 'Bonés e gorros exclusivos',
    price: 'Desde $12',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20bucket%20hat%20and%20beanie%20displayed%20on%20wooden%20mannequin%20head%20against%20exposed%20brick%20wall%2C%20urban%20streetwear%20product%20photography%2C%20warm%20spotlight%2C%20industrial%20loft%20aesthetic&width=500&height=500&seq=feat-v2-headwear&orientation=squarish',
  },
  {
    name: 'Sets',
    desc: 'Conjuntos coordenados',
    price: 'Desde $35',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20tracksuit%20set%20photographed%20on%20minimal%20white%20seamless%20studio%20backdrop%2C%20professional%20fashion%20catalog%20photography%2C%20bright%20even%20studio%20lighting%2C%20clean%20commercial%20aesthetic%2C%20front%20and%20slightly%20angled%20view&width=500&height=500&seq=feat-v2-sets&orientation=squarish',
  },
  {
    name: 'Jersey',
    desc: 'Jerseys esportivas autênticas',
    price: 'Desde $28',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Basketball%20jersey%20laid%20flat%20on%20hardwood%20court%20floor%20with%20court%20lines%20visible%2C%20arena%20overhead%20lighting%2C%20sports%20gear%20photography%2C%20dynamic%20composition%2C%20authentic%20game%20atmosphere&width=500&height=500&seq=feat-v2-jersey&orientation=squarish',
  },
  {
    name: 'Accessories',
    desc: 'Acessórios de moda',
    price: 'Desde $10',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20fashion%20rings%20chains%20and%20bracelets%20scattered%20on%20dark%20velvet%20surface%2C%20luxury%20jewelry%20flat%20lay%20photography%2C%20sparkling%20catchlights%2C%20dramatic%20rich%20contrast%2C%20high%20end%20accessories%20display&width=500&height=500&seq=feat-v2-accessories&orientation=squarish',
  },
];

export default function FeatureScroll() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-2">
              Mais Populares
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Produtos em{' '}
              <span className="text-accent-600">Destaque</span>
            </h2>
          </div>
          <span className="hidden md:inline-block px-4 py-1.5 bg-foreground-900 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
            2025
          </span>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {featureCards.map((card) => (
            <a
              key={card.name}
              href={card.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[220px] md:w-[260px] group cursor-pointer"
            >
              <div className="bg-background-100 rounded-xl overflow-hidden">
                <div className="aspect-square overflow-hidden">
                  <img
                    src={card.imageUrl}
                    alt={card.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4">
                  <p className="text-sm text-foreground-700">{card.name}</p>
                  <p className="text-xs text-foreground-500 mt-0.5">{card.desc}</p>
                  <p className="text-base font-bold text-foreground-900 mt-3">{card.price}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/artigo/hoobuy-sheet-guia-completo-2025"
            className="inline-flex items-center gap-2 text-sm text-accent-600 font-medium hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Ver Guia Completo
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}